import React, { useState, useEffect } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import groupService from '../../Group/services';
import collectionCategoryService from '../../CollectionCategory/services';
import divisionService from '../../Devision/services';
import CSVReader from 'react-csv-reader';
import { employeeCardUploadSchemaObject } from '../validations';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import CardHeader from '@material-ui/core/CardHeader';
import Box from '@material-ui/core/Box';
import MaterialTable from "material-table";
//import PerfectScrollbar from 'react-perfect-scrollbar';

import tokenDecoder from '../../../Common/tokenDecoder';


const screenCode = 'EMPLOYEEBULKUPLOAD'

export function EmployeeCardUploadAdd(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Employee Card Upload");
    const [buttonName, setButtonName] = useState("Upload")
    const [groups, setGroups] = useState([]);
    const [isChanged, setIsChanged] = useState(0);
    const [estate, setEstate] = useState();
    const [collectionPoint, setCollectionPoint] = useState();
    const [customerData, setcustomerData] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState();
    const [employeeCardUpload, setEmployeeCardUpload] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
        collectionCategoryID: '0',
        isRsm: false,
        employees: []
    });
    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [isFileChosen, setIsFileChosen] = useState(false);
    const [operationEntity, setOperationEntity] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [fileInfo, setFileInfo] = useState({});

    const schema = Joi.object(employeeCardUploadSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getEstateForDropdown()
        )
    }, [employeeCardUpload.groupID]);

    useEffect(() => {
        trackPromise(
            getCollectionPointForDropDown()
        )
        trackPromise(
            getCollectionCategoryForDropDown()
        )
    }, [employeeCardUpload.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEMPLOYEEBULKUPLOAD');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }
            setMultipleEstates(estateArray)

        }

        setEmployeeCardUpload({
            ...employeeCardUpload,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        trackPromise(
            getGroupDropdownData()
        )
    }

    async function getGroupDropdownData() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getEstateForDropdown() {
        const estate = await services.getOperationEntitiesByGroupForDropDown(employeeCardUpload.groupID);
        setOperationEntity(estate);
    }

    async function getCollectionPointForDropDown() {
        const collectionPoint = await services.getCollectionPointForDropDown(employeeCardUpload.operationEntityID);
        setCollectionPoint(collectionPoint);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategories = await collectionCategoryService.GetCollectionCategoryByOperationEntityID(employeeCardUpload.operationEntityID);
        setCollectionCategory(collectionCategories);
    }

    async function handleSave() {

        let datarest = await Promise.all(customerData.map(async data => {

            var employeeDetails = {
                employees: data,
                groupID: parseInt(employeeCardUpload.groupID),
                operationEntityID: parseInt(employeeCardUpload.operationEntityID),
                collectionPointID: parseInt(employeeCardUpload.collectionPointID),
                collectionCategoryID: parseInt(employeeCardUpload.collectionCategoryID),
                isRsm: employeeCardUpload.isRsm,
                createdBy: parseInt(tokenDecoder.getUserIDFromToken())
            }


            const response = await services.employeeCardBulkUpload(employeeDetails);
            if (response.statusCode == "Success") {

                setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })

            }
            else {
                setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
                return data;
            }
        }))

        var errorList = [];
        datarest.map((itemx) => {
            if (itemx != undefined) {
                errorList.push(itemx);
            }
        })
        setcustomerData(errorList);


        //setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<option key={key} value={key}>{value}</option>)
            }
        }
        return items
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setEmployeeCardUpload({
            ...employeeCardUpload,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID: '0',
            collectionCategoryID: '0'
        })
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setEmployeeCardUpload({
            ...employeeCardUpload,
            operationEntityID: target.value,
            collectionPointID: '0',
            collectionCategoryID: '0'
        })
    }

    function handleCollectionPointChange(target) {
        validateInputs(target);

        setEmployeeCardUpload({
            ...employeeCardUpload,
            collectionPointID: target.value
        })
    }

    function handleCollectionCategoryChange(target) {
        validateInputs(target);

        setEmployeeCardUpload({
            ...employeeCardUpload,
            collectionCategoryID: target.value
        })
    }

    function handleChange(e) {

        setEmployeeCardUpload({
            ...employeeCardUpload,
            isRsm: e.target.checked
        })
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, employeeCardUploadSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)
    }

    const handleForce = (data, fileInfo) => {

        if (customerData != null) {
            setIsFileChosen(true);
            setFileInfo(fileInfo);
            setEmployeeCardUpload({
                ...employeeCardUpload,
                employees: data
            })
            confirmUpload(data, fileInfo);
        }
    }

    function confirmUpload(data, fileInfo) {
        setcustomerData(data);

    }

    function clearData() {
        setEmployeeCardUpload({
            ...employeeCardUpload,
            groupID: '0',
            operationEntityID: '0',
            collectionPointID: '0',
            collectionCategoryID: '0',
            isRsm: false,
            employees: []
        });

        setcustomerData([]);

    }

    const papaparseOptions = {
        header: true,
        dynamicTyping: false,
        quoteChar: '"',
        skipEmptyLines: true,
        parseNumbers: true,
        transformHeader: header => header.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '')
    };

    return (
        <div>
            <LoadingSpinerComponent />
            <div className="card">
                <PageHeader
                    title={title}
                    isButtonEnable={false}
                />
                <div className="card-body">
                    <div className="row row-top-gap">
                        <div className="col-md-4 pb-1">
                            <InputLabel shrink id="groupID">Group *</InputLabel>
                            <Select fullWidth
                                labelId="groupID"
                                id="groupID"
                                disabled={!permissionList.isGroupFilterEnabled}
                                name="groupID"
                                value={employeeCardUpload.groupID}
                                onChange={(e) => handleGroupChange(e.target)}>
                                <option value="0">--Select Group--</option>
                                {generateDropDownMenu(groups)}
                            </Select>
                            {errors["groupID"] && <span id="errbranchCode" className="text text-danger">{errors["groupID"]}</span>}
                        </div>
                        <div className="col-md-4 pb-1">
                            <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                            <Select fullWidth
                                labelId="operationEntityID"
                                id="operationEntityID"
                                disabled={!permissionList.isOperationEntityFilterEnabled}
                                name="operationEntityID"
                                value={employeeCardUpload.operationEntityID}
                                onChange={(e) => handleEstateChange(e.target)}>
                                <option value="0">--Select Estate--</option>
                                {generateDropDownMenu(
                                    Object.fromEntries(
                                        Object.entries(operationEntity).filter(([key, value]) => {
                                            if (key === "0" || !value) return false;
                                            if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                                                return true;
                                            }
                                            return Object.values(multipleEstates).includes(value);
                                        })
                                    )
                                )}

                            </Select>
                            {errors["operationEntityID"] && <span id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</span>}
                        </div>
                        <div className="col-md-4 pb-1">
                            <InputLabel shrink id="collectionPointID">Division *</InputLabel>
                            <Select fullWidth
                                labelId="collectionPointID"
                                id="collectionPointID"
                                name="collectionPointID"
                                value={employeeCardUpload.collectionPointID}
                                onChange={(e) => handleCollectionPointChange(e.target)}>
                                <option value="0">--Select Division--</option>
                                {generateDropDownMenu(collectionPoint)}
                            </Select>
                            {errors["collectionPointID"] && <span id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</span>}
                        </div>
                        <div className="col-md-4 pb-1">
                            <InputLabel shrink id="collectionPointID">Collection Category *</InputLabel>
                            <Select fullWidth
                                labelId="collectionCategoryID"
                                id="collectionCategoryID"
                                name="collectionCategoryID"
                                value={employeeCardUpload.collectionCategoryID}
                                onChange={(e) => handleCollectionCategoryChange(e.target)}>
                                <option value="0">--Select Collection Category--</option>
                                {generateDropDownMenu(collectionCategory)}
                            </Select>
                            {errors["collectionCategoryID"] && <span id="errbranchCode" className="text text-danger">{errors["collectionCategoryID"]}</span>}
                        </div>
                    </div>
                    <div className="pt-3">
                        <label>Is Rsm</label>
                        <div className="form-group row">
                            <div className="col-md-4 pb-1">
                                <input
                                    className="mr-2"
                                    id="isRsm"
                                    switch="none"
                                    type="checkbox"
                                    name="isRsm"
                                    onChange={(e) => handleChange(e)}
                                    checked={employeeCardUpload.isRsm}
                                />
                                <label htmlFor="isRsm" data-on-label="Yes"
                                    data-off-label="No"></label>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 pb-1">
                        <button className="btn" style={{ marginTop: 20, marginRight: 10, backgroundColor: '#28a761', color: '#fff !important' }}>
                            <CSVReader
                                label={isFileChosen ? 'File Chosen' : 'Choose File'}
                                onFileLoaded={handleForce}
                                parserOptions={papaparseOptions}
                                inputId="react-csv-reader-input"
                                cssClass="csv-reader-input"
                            />
                        </button>
                        {isFileChosen ? <span>{fileInfo.name}</span> : null}
                    </div>
                </div>

                {customerData.length > 0 ?
                    <CardHeader style={{ marginLeft: '-1rem' }} titleTypographyProps={{ variant: 'h6' }}
                        title="Failed Records Present"
                    /> : null}
                {customerData.length > 0 ?
                    <MaterialTable

                        title="Employee Details"
                        columns={[
                            { title: 'Estate', field: 'estate' },
                            { title: 'Employee Type', field: 'employeeType' },
                            { title: 'Employee Category', field: 'employeeCategory' },
                            { title: 'Registration Number', field: 'registrationNumber' },
                            { title: 'First Name', field: 'firstName' },
                            { title: 'Gender', field: 'gender' },
                            { title: 'Maritial Status', field: 'maritalStatus' },
                            { title: 'Epf No', field: 'epfNo' },
                            { title: 'NIC', field: 'nic' },
                            { title: 'Religion', field: 'religion' },
                            { title: 'Office Number', field: 'officePhoneNo' },
                            // { title: 'Designation', field: 'designation' },
                            //{ title: 'Race', field: 'race' },
                            // { title: 'Name To Be Printed', field: 'nameToBePrinted' },
                            // { title: 'Employee Code', field: 'employeeCode' },
                            // { title: 'Country', field: 'country' },
                            // { title: 'Title', field: 'title' },
                            // { title: 'IsSupplemenatary', field: 'isSupplementary' },
                            // { title: 'Division Name', field: 'divisionName' },


                        ]}
                        data={customerData}
                        options={{
                            exportButton: false,
                            showTitle: false,
                            headerStyle: { textAlign: "left", height: '1%' },
                            cellStyle: { textAlign: "left" },
                            columnResizable: true,
                            actionsColumnIndex: -1,
                            pageSize: 10,
                            padding: "dense",
                            //doubleHorizontalScroll: true,
                            tableLayout: "auto",
                            // draggable: true

                        }}
                        actions={[

                        ]}
                    /> : null}

                {customerData.length > 0 ?
                    <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            onClick={() => (trackPromise(handleSave()))}
                        >
                            Upload
                        </Button>
                    </Box> : null}
                <MessageModal
                    hidden={messageModel.hidden}
                    messageType={messageModel.type}
                    messageDescription={messageModel.disciption}
                    clicked={modalDismissHandler}
                />
            </div>
        </div>
    );
}